module.exports = __webpack_public_path__ + "media/categories/1067-27e6dfd6.svg";